export default __webpack_public_path__ + "static/media/J-Goode.4a789ee2.jpg";